var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAboutusCustoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 37,
    viewBox: "0 0 43 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.2724 13.125L32.0771 0.383353C32.0467 0.345983 32.0085 0.315797 31.965 0.294958C31.9216 0.274119 31.8741 0.263143 31.826 0.262817H11.1742C11.0788 0.262817 10.9833 0.308018 10.9231 0.383353L0.727768 13.125C0.680565 13.1847 0.655731 13.2591 0.657566 13.3352C0.6594 13.4113 0.687786 13.4844 0.737813 13.5418L21.259 36.6194C21.3193 36.6897 21.4097 36.7249 21.5001 36.7249C21.5905 36.7249 21.6759 36.6847 21.7412 36.6194L42.2624 13.5418C42.3124 13.4844 42.3408 13.4113 42.3426 13.3352C42.3444 13.2591 42.3196 13.1847 42.2724 13.125ZM28.1898 3.14563L29.9175 9.87052L23.2629 3.14563H28.1898ZM28.6017 12.1105H14.3985L21.5001 4.93358L28.6017 12.1105ZM14.8104 3.14563H19.7373L13.0777 9.87052L14.8104 3.14563ZM12.1284 3.49719L9.91359 12.1105H5.23781L12.1284 3.49719ZM5.55924 14.6216H10.3003L16.6184 27.0619L5.55924 14.6216ZM21.5001 31.12L13.1178 14.6216H29.8773L21.5001 31.12ZM26.3768 27.0619L32.6999 14.6216H37.4409L26.3768 27.0619ZM33.0866 12.1105L30.8717 3.49719L37.7624 12.1105H33.0866Z",
    fill: "#5CBF14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutusCustoIcon);
export default __webpack_public_path__ + "static/media/aboutus_custo-icon.b50c7f2e0e87c252f4daabd86499503a.svg";
export { ForwardRef as ReactComponent };